<div class="modal-content">
  <div class="modal-header">
    <h3>{{'Change password' | translate}}</h3>
    <div class="modal-close">
      <img class="cross-close" src="/content/icons/Close-Black.svg" (click)="activeModal.close(false)">
    </div>
  </div>
  <div class="modal-body">
    <form (ngSubmit)="changePassword()" [formGroup]="passwordForm">
      <div class="form-group">
        <label for="newPassword">{{ 'global.form.newpassword.label' | translate }}</label>
        <input id="newPassword" formControlName="newPassword" type="password" placeholder="{{ 'global.form.newpassword.placeholder' | translate}}">
      </div>
      <div class="form-group">
        <label for="confirmPassword">{{ 'global.form.confirmpassword.label' | translate }}</label>
        <input id="confirmPassword" formControlName="confirmPassword" type="password" placeholder="{{ 'global.form.confirmpassword.placeholder' | translate }}">
        <app-form-control-error-message [control]="passwordForm.get('confirmPassword')" labelKey="Confirm password"></app-form-control-error-message>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="10px">
      <button mat-stroked-button (click)="activeModal.close(false)">{{'cancel' | translate}}</button>
      <button mat-stroked-button type="submit" [disabled]="passwordForm.invalid" (click)="changePassword()">{{"OK" | translate}}</button>
    </div>
  </div>
</div>
